package floris.graphics.models.domain.models

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.techstack.TechstackDto
import org.w3c.dom.url.URL

data class Techstack(
    val id: String = "",
    val name: String = "",
    val logoMediaFile: MediaFile? = null,
    val techstack: Techstack? = null,
    val subTechstacks: List<Techstack>? = null,
    override val createdAt: String = "",
    override val updatedAt: String = "",
) : DateAble

//TODO: test this out with triple nested techstacks!!
fun Techstack.toDto(): TechstackDto = TechstackDto(
    id = this.id,
    name = this.name,
    logoMediaFile = logoMediaFile?.toDto(),
    subTechstacks = subTechstacks?.map { it.toDto() },
    techstack = this.techstack?.toDto(),
    createdAt = this.createdAt,
    updatedAt = this.updatedAt
)

fun TechstackDto.toTechstack(): Techstack = Techstack(
    id = id,
    name = name,
    logoMediaFile = logoMediaFile?.toMediaFile(),
    subTechstacks = subTechstacks?.map { it.toTechstack() },
    techstack = techstack?.toTechstack(),
    createdAt = createdAt,
    updatedAt = updatedAt
)